import React, { useState, useEffect } from "react";
import moment from "moment";
import {
    ComposedChart,
    Line,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    ReferenceArea,
    ReferenceLine,
    Tooltip
} from 'recharts';
import {
    ConvertData, CustomTooltip, getGroupedSeriesByUUID, getGroupedSeriesByGroupmentAndSerie,
    GetXLSXData, createOccupationArea, CustomizedReferenceLabel, convertUrlColorToHexa
} from './ChartsV2Functions';
import "./ChartV2.css";
import uuid from "react-uuid";

export default function ChartV2ComposedTimeAxis(props) {
    const { chart, data, setData, entityParameters, displayOccupationSchedule } = props;
    const [activelegend, setActivelegend] = useState([]);
    const [groupedseries, setGroupedseries] = useState([]);
    const [zoomed, setZoomed] = useState(false);
    const [zoomObject, setZoomObject] = useState({
        refAreaLeft: '',
        refAreaRight: '',
    });
    const [displayeddata, setDisplayeddata] = useState([]);
    const [occupationareas, setOccupationareas] = useState([]);


    // console.log('composedchart',chart);

    useEffect(() => {
        chart.series.forEach((serie) => {
            serie.uuid = uuid();
            if(serie.type && serie.type === 'line')
            {
                serie.color = convertUrlColorToHexa(serie.color);
            }
            // console.log(serie.color);
        });
        let datatmp = ConvertData(chart);
        setData(datatmp);
        setDisplayeddata(datatmp);
        let groupedseriestmp;
        if (!chart.distributiongroupment || chart.distributiongroupment === 'no') {
            groupedseriestmp = getGroupedSeriesByUUID(chart);
        }
        else
            groupedseriestmp = getGroupedSeriesByGroupmentAndSerie(chart);
        // console.log(groupedseriestmp);
        groupedseriestmp.sort((a, b) => a.position - b.position);
        // console.log(groupedseriestmp);
        setGroupedseries(groupedseriestmp);
        let activelegendtmp = [];
        groupedseriestmp.forEach((serie) => {
            activelegendtmp.push({ dataKey: serie.groupid, hide: false });
        });
        setActivelegend(activelegendtmp);

        GetXLSXData(chart, datatmp, groupedseriestmp);
        let occupationareastmp = createOccupationArea(datatmp, entityParameters);
        setOccupationareas(occupationareastmp);
    }, []);

    const handleMouseDown = (e) => {
        if (e && e.activeLabel) {
            setZoomObject(prev => ({
                ...prev,
                refAreaLeft: e.activeLabel
            }));
        }
    };
    const handleMouseMove = (e) => {
        if (e && e.activeLabel && zoomObject.refAreaLeft) {
            setZoomObject(prev => ({ ...prev, refAreaRight: e.activeLabel }));
        }
    };
    const handleMouseUp = (e) => {
        // let tmpzoomobject = { ...zoomObject };
        if (zoomObject.refAreaRight && zoomObject.refAreaLeft) {
            if (zoomObject.refAreaLeft > zoomObject.refAreaRight) {
                trunkdisplayeddata(zoomObject.refAreaRight, zoomObject.refAreaLeft);
            }
            else {
                trunkdisplayeddata(zoomObject.refAreaLeft, zoomObject.refAreaRight);
            }
            setZoomObject(prev => ({
                ...prev,
                refAreaLeft: '',
                refAreaRight: ''
            }));
        }
    };
    const trunkdisplayeddata = (left, right) => {
        let fromIndex = data.findIndex((x) => x.timestamp === left);
        let toIndex = data.findIndex((x) => x.timestamp === right);
        // console.log(fromIndex, toIndex, data.length);
        //next conditions and calculations to avoid empty zoom
        if (fromIndex > 0)
            fromIndex = fromIndex - 1;
        if (toIndex < (data.length - 1))
            toIndex = toIndex + 1;
        //console.log(fromIndex, (toIndex - 1));
        if (fromIndex < (toIndex - 2)) {
            const refData = data.slice(fromIndex, toIndex);
            //console.log(refData);
            setDisplayeddata(refData);
            setZoomed(true);
        }

    }


    const zoomOut = () => {
        setDisplayeddata(data);
        setZoomObject({
            refAreaLeft: '',
            refAreaRight: '',
        });
        setZoomed(false);
    }

    const handleLegendClick = (node) => {
        // console.log(node);
        node.inactive = !node.inactive;
        let activelegendtmp = [...activelegend];
        // console.log(activelegendtmp);
        activelegendtmp.find((legend) => legend.dataKey == node.dataKey).hide = !activelegendtmp.find((legend) => legend.dataKey == node.dataKey).hide;
        setActivelegend(activelegendtmp);
    };


    return (
        <>
            {zoomed ?
                <button type="button" className="zoomoutbutton" onClick={() => zoomOut()}>
                    Dézoomer
                </button> : <></>
            }
            <ResponsiveContainer width="100%" height="100%">
                <ComposedChart
                    width={500}
                    height={300}
                    data={displayeddata}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 40,
                    }}
                    onMouseDown={e => handleMouseDown(e)}
                    onMouseMove={e => handleMouseMove(e)}
                    onMouseUp={(e) => handleMouseUp(e)}
                    onMouseLeave={e => setZoomObject(prev => ({
                        ...prev,
                        refAreaLeft: '',
                        refAreaRight: '',
                    }))}
                >
                    <defs>
                        <linearGradient id="greentored" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#8bbc21" stopOpacity={1} />
                            <stop offset="100%" stopColor="#c42525" stopOpacity={1} />
                        </linearGradient>
                    </defs>
                    <defs>
                        <linearGradient id="redtogreen" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#c42525" stopOpacity={1} />
                            <stop offset="100%" stopColor="#8bbc21" stopOpacity={1} />
                        </linearGradient>
                    </defs>
                    <defs>
                        {/* RED */}
                        <radialGradient id="colorRed" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#C53F3F" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#8E0018" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorRed2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#9D3232" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#710013" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorRed3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#762525" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#55000E" stopOpacity={0.9} />
                        </radialGradient>

                        {/* ORANGE */}
                        <radialGradient id="colorOrange" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#FF763A" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#C54608" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorOrange2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#CC5E2E" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#9D3806" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorOrange3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#994622" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#762A04" stopOpacity={0.9} />
                        </radialGradient>

                        {/* YELLOW */}
                        <radialGradient id="colorYellow" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#D6D22F" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#A1A100" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorYellow2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#ABA825" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#808000" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorYellow3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#807E1C" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#606000" stopOpacity={0.9} />
                        </radialGradient>

                        {/* GREEN */}
                        <radialGradient id="colorGreen" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#91C73C" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#5F9600" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorGreen2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#749F30" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#4C7800" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorGreen3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#577724" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#395A00" stopOpacity={0.9} />
                        </radialGradient>

                        {/* BLUE */}
                        <radialGradient id="colorBlue" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#3E8FC6" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#006295" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorBlue2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#31729E" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#004E77" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorBlue3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#255576" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#003A59" stopOpacity={0.9} />
                        </radialGradient>

                        {/* PURPLE */}
                        <radialGradient id="colorPurple" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#6B3CC8" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#340C96" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorPurple2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#5530A0" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#290978" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorPurple3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#402478" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#1F075A" stopOpacity={0.9} />
                        </radialGradient>

                        {/* GREY */}
                        <radialGradient id="colorGrey" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#9798A0" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#605F70" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorGrey2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#787980" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#4C4C59" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="colorGrey3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#5A5B60" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#393943" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE A */}
                        <radialGradient id="dpeA" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#008A32" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#476E00" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeA2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#006E28" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#385800" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeA3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#00521E" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#2A4200" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE B */}
                        <radialGradient id="dpeB" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#91C73C" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#5F9600" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeB2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#749F30" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#4C7800" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeB3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#577724" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#395A00" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE C */}
                        <radialGradient id="dpeC" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#D6D22F" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#A1A100" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeC2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#ABA825" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#808000" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeC3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#807E1C" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#606000" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE D */}
                        <radialGradient id="dpeD" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#FFFF66" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#B5B548" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeD2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#CCCC51" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#909039" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeD3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#99993D" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#6C6C2B" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE E */}
                        <radialGradient id="dpeE" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#F8BB00" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#CE9A00" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeE2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#C69500" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#A47B00" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeE3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#947000" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#7B5C00" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE F */}
                        <radialGradient id="dpeF" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#FF763A" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#C54608" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeF2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#CC5E2E" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#9D3806" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeF3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#994622" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#762A04" stopOpacity={0.9} />
                        </radialGradient>

                        {/* DPE G */}
                        <radialGradient id="dpeG" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#C53F3F" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#8E0018" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeG2" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#9D3232" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#710013" stopOpacity={0.9} />
                        </radialGradient>
                        <radialGradient id="dpeG3" x1="1" y1="1" x2="0" y2="0">
                            <stop offset="0%" stopColor="#762525" stopOpacity={0.9} />
                            <stop offset="100%" stopColor="#55000E" stopOpacity={0.9} />
                        </radialGradient>
                    </defs>
                    <CartesianGrid
                        strokeDasharray="1"
                        vertical={false}
                    />
                    <XAxis
                        allowDataOverflow={true}
                        dataKey="timestamp"
                       // type='number'
                        domain={["auto", "auto"]}
                       // scale='time'
                        tickFormatter={(unixTime) => chart.xaxistimetick === 'day' ? moment(unixTime).utc().format('DD/MM/yyyy')
                            : chart.xaxistimetick === 'month' ? moment(unixTime).utc().format('MM/yyyy') : chart.xaxistimetick === 'year' ? moment(unixTime).utc().format('yyyy')
                            : moment(unixTime).utc().format('DD/MM/yyyy')}
                        name='Date'
                        padding={'gap'}
                        angle={325}
                        tickMargin={25}
                        axisLine={false}
                    />
                    <YAxis
                        allowDataOverflow={true}
                        label={{ value: chart.yaxis1unit, angle: -90, position: 'insideLeft' }}
                        yAxisId="left"
                        orientation="left"
                        axisLine={false}
                        tickLine={false}
                        domain={[(min) => {
                            return min > 0 ? 0 : min;
                        }, "auto"]}
                        tickFormatter={(value) => value > 10000 ? (value / 1000) + "k" : "" + value}
                    />
                    {
                        chart.yaxis2 ?
                            <YAxis
                                allowDataOverflow={true}
                                label={{ value: chart.yaxis2unit, angle: -90, position: 'insideRight' }}
                                yAxisId="right"
                                orientation="right"
                                axisLine={false}
                                tickLine={false}
                                domain={[(min) => {
                                    return min > 0 ? 0 : min;
                                }, "auto"]}
                                tickFormatter={(value) => value > 10000 ? (value / 1000) + "k" : "" + value}
                            /> : <></>
                    }
                    <Tooltip
                        cursor={{ fill: 'transparent' }}
                        content={<CustomTooltip xaxistimetick={chart.xaxistimetick} />}
                    />
                    {displayOccupationSchedule ? occupationareas : <></>}
                    {zoomObject.refAreaLeft && zoomObject.refAreaRight ? (
                        <ReferenceArea x1={zoomObject.refAreaLeft} x2={zoomObject.refAreaRight} ifOverflow='hidden' yAxisId={'left'} strokeOpacity={1} />
                    ) : null}
                    {
                        chart.references?.map((ref) =>
                            <ReferenceLine ifOverflow={'extendDomain'} y={ref.value}
                                //label={ref.name}
                                isFront={true}
                                label={<CustomizedReferenceLabel text={ref.name} />}
                                yAxisId={ref.yaxis} stroke="black" />
                        )
                    }
                    <Legend
                        wrapperStyle={{ marginBottom: -40 }}
                        onClick={handleLegendClick}
                    />
                    {
                        groupedseries.map((serie) =>
                            (serie.type && serie.type === 'column') ?
                                <Bar
                                    stackId={serie.stackId}
                                    isAnimationActive={false}
                                    background={false}
                                    dataKey={serie.groupid}
                                    fill={serie.color}
                                    name={serie.groupname}
                                    hide={activelegend.find((legend) => legend.dataKey == (serie.groupid))?.hide}
                                    yAxisId={serie.yaxis || 'left'}
                                    unit={(serie.yaxis && serie.yaxis === 'right') ? chart.yaxis2unit : chart.yaxis1unit}
                                // barSize={100}
                                />
                                :
                                <Line
                                    connectNulls
                                    isAnimationActive={false}
                                    background={false}
                                    dataKey={serie.groupid}
                                    dot={false}
                                    stroke={serie.color}
                                    strokeWidth={2}
                                    name={serie.groupname}
                                    hide={activelegend.find((legend) => legend.dataKey == (serie.groupid))?.hide}
                                    yAxisId={serie.yaxis || 'left'}
                                    unit={(serie.yaxis && serie.yaxis === 'right') ? chart.yaxis2unit : chart.yaxis1unit}
                                />
                        )
                    }

                </ComposedChart>

            </ResponsiveContainer>
        </>
    );
}